// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"NewsItem-module--image-container--2zJQw","image":"NewsItem-module--image--3eB32"};